var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((new Array(20)),function(i){return _c('div',{key:i,staticClass:"d-flex justify-content-between"},_vm._l((_vm.fields),function(field,index){return _c('div',{key:index,staticClass:"table-row animated-text-line my-3",style:({ width:field.width - 1 + '%' })})}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }